import { END_POINTS } from '../helpers';
import { CommonBody, VehicleType } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetVehicleTypeResponse = {
  count: number;
  data: VehicleType[];
};

export const vehicleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleTypes: builder.query<
      CommonResponse & { data: GetVehicleTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getVehicleTypes}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),

    deleteVehicleType: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteVehicleType}/${id}`,
        method: 'DELETE',
      }),
    }),
    getVehicleTypeById: builder.query<CommonResponse & { data: VehicleType }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getVehicleById}/${id}`,
        method: 'GET',
      }),
    }),

    addVehicle: builder.mutation<CommonResponseType & { data: VehicleType }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.vehicleType}`,
        method: 'POST',
        body,
      }),
    }),
    updateVehicleType: builder.mutation<
      CommonResponseType & { data: VehicleType },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateVehicle}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddVehicleMutation,
  useUpdateVehicleTypeMutation,
  useLazyGetVehicleTypesQuery,
  useLazyDeleteVehicleTypeQuery,
  useLazyGetVehicleTypeByIdQuery,
} = vehicleApi;
